import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { EVENTS } from 'alerting/constants/AlertConstants'
import { CardTitle } from '../../../../components/card/NewCard'
import Checkbox from 'components/forms/Checkbox'
import Input from 'components/forms/Input'
import Textarea from 'components/forms/Textarea'
import Icon from 'components/icon/Icon'
import GlobalCardList from 'components/list/cardList/GlobalCardList'
import EventsAction from 'events/actions/EventsAction'
import { EVENT_TYPES } from 'events/constants/EventsConstants'
import { groupBy } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import EventCard from 'station/components/event/EventCard'
import { getEventColor } from 'utils/ColorUtil'
import { getDate, getDateWithHour, getHour, getYearOrString } from 'utils/DateUtil'
import { onChangeDate, onChangeHour } from 'utils/FormUtils'
import { getLabel } from 'utils/StoreUtils'

const STEP_TYPE = 'STEP_TYPE'
const STEP_FORM = 'STEP_FORM'

const EventsTab = ({
    events = [],
    station = {},
    onReload = () => { },
    showTitle = true,
}) => {
    const dispatch = useDispatch()

    const {
        accountUser,
    } = useSelector(store => ({
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const [eventStep, setEventStep] = useState(STEP_TYPE)
    const [isOpen, setIsOpen] = useState(false)
    const [event, setEvent] = useState({
        eventDate: moment().valueOf(),
        date: moment().valueOf(),
        endDate: moment().valueOf(),
        eventHour: moment().valueOf(),
        eventType: 'C',
        graph: '1',
        chgtpiles: '0',
        bankExport: '0',
        razstation: '0',
        contactCode: accountUser.contactCode,
    })


    const eventsDesc = events.sort((a, b) => b.date - a.date)
    const groups = groupBy(eventsDesc, e => getYearOrString(getDate(e.date), i18n.thisYear))
    const eventData = Object.keys(groups).map(key => ({
        title: key,
        cards: groups[key].map(e => ({
            content: (
                <EventCard
                    event={e}
                    link={`/station/${station.typeName}/${station.id}/event/`}
                    stationType={station.typeName}
                />
            ),
            color: getEventColor(e.eventType),
        })),
    }))
    const reset = () => {
        setEventStep(STEP_TYPE)
        setIsOpen(false)
        setEvent({
            eventDate: moment().valueOf(),
            date: moment().valueOf(),
            endDate: moment().valueOf(),
            eventHour: moment().valueOf(),
            eventType: 'C',
            graph: '1',
            chgtpiles: '0',
            bankExport: '0',
            razstation: '0',
            contactCode: accountUser.contactCode,
        })
    }
    return (
        <>
            <Card>
                {showTitle && (
                    <CardTitle
                        title={`${i18n.events} (${events.length} ${i18n.elements})`}
                        actions={[{ icon: 'note_add', onClick: () => setIsOpen(true) }]}
                    />
                )}
                <CardContent>
                    <GlobalCardList
                        data={eventData}
                        collapsible
                        smallTitle
                    />
                </CardContent>
            </Card>
            <Dialog
                fullWidth
                maxWidth='lg'
                onClose={() => setIsOpen(false)}
                open={isOpen}
            >
                <DialogTitle>
                    {
                        eventStep === STEP_TYPE && i18n.SelectEventTypeToCreate
                    }
                    {
                        eventStep === STEP_FORM && (
                            <Grid container sx={{ alignItems: 'center' }}>
                                <Grid size={11}>
                                    {i18n.defineEvent}
                                </Grid>
                                <Grid size={1}>
                                    <Icon icon={getLabel(EVENT_TYPES, event.eventType, 'icon')} clickable={false} />
                                </Grid>
                            </Grid>
                        )
                    }
                </DialogTitle>
                <DialogContent>
                    {
                        eventStep === STEP_TYPE && (
                            <div className='padding-1'>
                                <Grid container>
                                    <Grid size={12}>
                                        {
                                            EVENT_TYPES.filter(e => ['S', 'C'].includes(e.code)).map(eventType => (
                                                <Grid container sx={{ paddingBottom: 1 }}>
                                                    <Grid size={12}>
                                                        <Checkbox
                                                            label={
                                                                <Grid container sx={{ alignItems: 'center', flexWrap: 'nowrap' }}>
                                                                    <Icon icon={eventType.icon} />
                                                                    <h6 className='padding-left-1'>
                                                                        {i18n[eventType.label]}
                                                                    </h6>
                                                                </Grid>
                                                            }
                                                            checked={event.eventType === eventType.code}
                                                            onChange={() => setEvent(p => ({ ...p, eventType: eventType.code }))}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </Grid>
                            </div>
                        )
                    }
                    {
                        eventStep === STEP_FORM && (
                            <div className='padding-1'>
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Input value={getDate(event.date)} title={i18n.startDate} onChange={v => onChangeDate(v, v2 => setEvent(p => ({ ...p, date: v2, startDate: v2 })))} />
                                    </Grid>
                                    <Grid size={6}>
                                        <Input value={getHour(event.eventHour)} title={i18n.startHour} onChange={v => onChangeHour(v, v2 => setEvent(p => ({ ...p, eventHour: v2 })))} />
                                    </Grid>
                                </Grid>
                                {
                                    event.eventType !== 'C' && (
                                        <Grid container spacing={1}>
                                            <Grid size={6}>
                                                <Input value={getDate(event.endDate)} title={i18n.endDate} onChange={v => onChangeDate(v, v2 => setEvent(p => ({ ...p, endDate: getDateWithHour(v2, event.endDate).valueOf() })))} />
                                            </Grid>
                                            <Grid size={6}>
                                                <Input value={getHour(event.endDate)} title={i18n.endHour} onChange={v => onChangeHour(v, v2 => setEvent(p => ({ ...p, endDate: getDateWithHour(event.endDate, v2).valueOf() })))} />
                                            </Grid>
                                        </Grid>
                                    )
                                }
                                <Grid container sx={{ paddingBottom: 1 }}>
                                    <Grid size={12}>
                                        <Textarea value={event.comment} title={i18n.comment} onChange={v => setEvent(p => ({ ...p, comment: v }))} />
                                    </Grid>
                                </Grid>
                            </div>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    {
                        eventStep === STEP_FORM && (
                            <div style={{ marginRight: 'auto', marginLeft: '0' }}>
                                <Button
                                    variant='outlined'
                                    onClick={() => setEventStep(STEP_TYPE)}
                                >
                                    {i18n.previous}
                                </Button>
                            </div>
                        )
                    }
                    <Button
                        variant='outlined'
                        onClick={reset}
                    >
                        {i18n.cancel}
                    </Button>
                    {
                        eventStep === STEP_TYPE && (
                            <Button
                                variant='contained'
                                onClick={() => setEventStep(STEP_FORM)}
                            >
                                {i18n.next}
                            </Button>
                        )
                    }
                    {
                        eventStep === STEP_FORM && (
                            <Button
                                variant='contained'
                                onClick={() => dispatch(EventsAction.addEvent(station.typeName, station.id, event)).then(() => {
                                    reset()
                                    onReload(station, EVENTS)
                                })}
                            >
                                {i18n.register}
                            </Button>
                        )
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

EventsTab.propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({})),
    station: PropTypes.shape({}),
    onReload: PropTypes.func,
    showTitle: PropTypes.bool,
}

export default EventsTab